import * as React from "react";
import { SVGProps } from "react";

const SvgAceClubs = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 287 402"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M275.8 0H11.1S0 .3 0 15v371.7c0 14.7 11.1 15 11.1 15h264.6s11.1-.3 11.1-15V15c.1-14.7-11-15-11-15Z"
      fill="#fff"
    />
    <mask
      id="ace-clubs_svg__b"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={216}
      width={287}
      height={186}
    >
      <path
        d="M169.2 216.8c-56.4 0-112.8 0-169.2.1v169.8c0 14.7 11.1 15 11.1 15h264.7s11.1-.3 11.1-15V216.8H169.2Z"
        fill="url(#ace-clubs_svg__a)"
      />
    </mask>
    <g mask="url(#ace-clubs_svg__b)">
      <path
        d="M169.2 216.8c-56.4 0-112.8 0-169.2.1v169.8c0 14.7 11.1 15 11.1 15h264.7s11.1-.3 11.1-15V216.8H169.2Z"
        fill="url(#ace-clubs_svg__c)"
      />
    </g>
    <mask
      id="ace-clubs_svg__e"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={287}
      height={201}
    >
      <path
        d="M0 200.4c24.1 0 48.3 0 72.4.1 69.6 0 139.2 0 208.7.1h5.7V15c0-14.7-11.1-15-11.1-15H11.1S0 .3 0 15v185.4Z"
        fill="url(#ace-clubs_svg__d)"
      />
    </mask>
    <g mask="url(#ace-clubs_svg__e)">
      <path
        d="M0 200.4c24.1 0 48.3 0 72.4.1 69.6 0 139.2 0 208.7.1h5.7V15c0-14.7-11.1-15-11.1-15H11.1S0 .3 0 15v185.4Z"
        fill="url(#ace-clubs_svg__f)"
      />
    </g>
    <mask
      id="ace-clubs_svg__h"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={5}
      y={0}
      width={282}
      height={402}
    >
      <path
        d="M286.3 15v371c0 14.7-11.1 15-11.1 15H10.3s-2.4-.1-5-1.6c2.9 2.1 5.8 2.2 5.8 2.2h264.6s11.1-.3 11.1-15V15c0-14.7-11.1-15-11.1-15h-.6c.1 0 11.2.3 11.2 15Z"
        fill="url(#ace-clubs_svg__g)"
      />
    </mask>
    <g mask="url(#ace-clubs_svg__h)">
      <path
        d="M286.3 15v371c0 14.7-11.1 15-11.1 15H10.3s-2.4-.1-5-1.6c2.9 2.1 5.8 2.2 5.8 2.2h264.6s11.1-.3 11.1-15V15c0-14.7-11.1-15-11.1-15h-.6c.1 0 11.2.3 11.2 15Z"
        fill="url(#ace-clubs_svg__i)"
      />
    </g>
    <mask
      id="ace-clubs_svg__k"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={282}
      height={402}
    >
      <path
        d="M.6 386.7v-371C.6 1 11.7.7 11.7.7h265s2.4.1 5 1.6C278.8.2 275.9.1 275.9.1H11.1S0 .4 0 15.1v371.7c0 14.7 11.1 15 11.1 15h.6c0-.1-11.1-.4-11.1-15.1Z"
        fill="url(#ace-clubs_svg__j)"
      />
    </mask>
    <g mask="url(#ace-clubs_svg__k)">
      <path
        d="M.6 386.7v-371C.6 1 11.7.7 11.7.7h265s2.4.1 5 1.6C278.8.2 275.9.1 275.9.1H11.1S0 .4 0 15.1v371.7c0 14.7 11.1 15 11.1 15h.6c0-.1-11.1-.4-11.1-15.1Z"
        fill="url(#ace-clubs_svg__l)"
      />
    </g>
    <mask
      id="ace-clubs_svg__n"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={29}
      width={1}
      height={347}
    >
      <path d="M0 29v346.3l.6-2.1V35.3L0 29Z" fill="url(#ace-clubs_svg__m)" />
    </mask>
    <g mask="url(#ace-clubs_svg__n)">
      <path d="M0 29v346.3l.6-2.1V35.3L0 29Z" fill="url(#ace-clubs_svg__o)" />
    </g>
    <path
      d="M22.8 79.9c-.6 7.4-4.8 12.6-4.8 12.6h9.6s-4.2-5.2-4.8-12.6Z"
      fill="#000"
    />
    <path
      d="M29.8 71.4c-1 0-1.9.2-2.7.5l-.1-.1c1.7-1.3 2.8-3.3 2.8-5.6 0-3.9-3.1-7-7-7s-7 3.1-7 7c0 2.4 1.2 4.6 3.1 5.8-.9-.5-2-.7-3.1-.7-3.9 0-7 3.1-7 7s3.1 7 7 7c3.8 0 6.8-3 7-6.7.2 3.7 3.2 6.7 7 6.7 3.9 0 7-3.1 7-7 0-3.8-3.1-6.9-7-6.9ZM27 52v-1.2c.8-.2 1.5-.4 1.9-.6.4-.2.7-.5.9-.8.2-.4.3-.8.3-1.5 0-.6-.1-1.2-.2-1.9s-.3-1.4-.6-2.2l-.9-3.3H16.5l-.9 2.5c-.4 1.3-.7 2.2-.9 2.8-.1.6-.2 1.2-.2 1.8 0 1 .3 1.8.8 2.2.5.5 1.3.8 2.4.9v1.2H6.9v-1.2c.9-.2 1.8-.7 2.5-1.6.7-.9 1.4-2.3 2-4.1L22 16.9h4l8.6 28.3c.4 1.3.8 2.3 1.1 3a5 5 0 0 0 1.1 1.6c.4.4 1 .7 1.8.9v1.2H27v.1Zm-9.8-13.7h10.6L23 21.9l-5.8 16.4ZM263.4 320.8c.6-7.5 4.8-12.7 4.8-12.7h-9.6c-.1 0 4.1 5.2 4.8 12.7Z"
      fill="#000"
    />
    <path
      d="M256.4 329.3c1 0 1.9-.2 2.7-.5l.1.1c-1.7 1.3-2.8 3.3-2.8 5.6 0 3.9 3.1 7 7 7s7-3.1 7-7c0-2.4-1.2-4.6-3.1-5.8.9.5 2 .7 3.1.7 3.9 0 7-3.1 7-7s-3.1-7-7-7c-3.8 0-6.8 3-7 6.7-.2-3.7-3.2-6.7-7-6.7-3.9 0-7 3.1-7 7-.1 3.7 3.1 6.9 7 6.9ZM259.2 348.7v1.2c-.8.2-1.5.4-1.9.6-.4.2-.7.5-.9.8-.2.4-.3.8-.3 1.5 0 .6.1 1.2.2 1.9s.3 1.4.6 2.2l.9 3.3h11.8l.9-2.5c.4-1.3.7-2.2.9-2.8.1-.6.2-1.2.2-1.8 0-1-.3-1.8-.8-2.2-.5-.5-1.3-.8-2.4-.9v-1.2h10.8v1.2c-.9.2-1.8.7-2.5 1.6-.7.9-1.4 2.3-2 4.1l-10.6 28.1h-4l-8.6-28.3c-.4-1.3-.8-2.3-1.1-3a5 5 0 0 0-1.1-1.6c-.4-.4-1-.7-1.8-.9v-1.2h11.7v-.1Zm9.7 13.7h-10.6l4.8 16.4 5.8-16.4ZM143.4 208.3c-1.2 14.8-9.6 25.2-9.6 25.2H153s-8.3-10.4-9.6-25.2Z"
      fill="#000"
    />
    <path
      d="M157.3 191.5c-1.9 0-3.7.4-5.4 1.1l-.1-.1c3.3-2.5 5.5-6.6 5.5-11.1 0-7.7-6.2-13.9-13.9-13.9s-13.9 6.2-13.9 13.9c0 4.8 2.5 9.1 6.2 11.6-1.9-.9-4-1.5-6.2-1.5-7.7 0-13.9 6.2-13.9 13.9s6.2 13.9 13.9 13.9c7.5 0 13.6-5.9 13.9-13.3.3 7.4 6.4 13.3 13.9 13.3 7.7 0 13.9-6.2 13.9-13.9 0-7.6-6.2-13.9-13.9-13.9Z"
      fill="#000"
    />
    <defs>
      <radialGradient
        id="ace-clubs_svg__a"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(139.03 -136.917) scale(580.826)"
      >
        <stop offset={0.616} />
        <stop offset={0.752} stopColor="#020202" />
        <stop offset={0.804} stopColor="#090909" />
        <stop offset={0.841} stopColor="#151515" />
        <stop offset={0.872} stopColor="#262626" />
        <stop offset={0.899} stopColor="#3C3C3C" />
        <stop offset={0.922} stopColor="#585858" />
        <stop offset={0.944} stopColor="#797979" />
        <stop offset={0.963} stopColor="#9F9F9F" />
        <stop offset={0.982} stopColor="#CBCBCB" />
        <stop offset={0.998} stopColor="#F9F9F9" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="ace-clubs_svg__c"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(139.03 -136.917) scale(580.826)"
      >
        <stop offset={0.616} stopColor="#fff" />
        <stop offset={0.788} stopColor="#FDFDFD" />
        <stop offset={0.854} stopColor="#F6F6F6" />
        <stop offset={0.901} stopColor="#EAEAEA" />
        <stop offset={0.94} stopColor="#D9D9D9" />
        <stop offset={0.974} stopColor="#C3C3C3" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="ace-clubs_svg__d"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(144.776 370.682) scale(416.199)"
      >
        <stop offset={0.616} />
        <stop offset={0.71} stopColor="#020202" />
        <stop offset={0.762} stopColor="#0A0A0A" />
        <stop offset={0.805} stopColor="#181818" />
        <stop offset={0.842} stopColor="#2C2C2C" />
        <stop offset={0.875} stopColor="#464646" />
        <stop offset={0.906} stopColor="#656565" />
        <stop offset={0.935} stopColor="#8A8A8A" />
        <stop offset={0.963} stopColor="#B6B6B6" />
        <stop offset={0.988} stopColor="#E5E5E5" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="ace-clubs_svg__f"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(144.776 370.682) scale(416.199)"
      >
        <stop offset={0.616} stopColor="#fff" />
        <stop offset={0.747} stopColor="#FDFDFD" />
        <stop offset={0.821} stopColor="#F5F5F5" />
        <stop offset={0.88} stopColor="#E7E7E7" />
        <stop offset={0.932} stopColor="#D3D3D3" />
        <stop offset={0.978} stopColor="#BABABA" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="ace-clubs_svg__g"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-12.256 -.163) scale(462.125)"
      >
        <stop offset={0.099} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="ace-clubs_svg__i"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-12.256 -.163) scale(462.125)"
      >
        <stop offset={0.099} stopColor="#fff" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="ace-clubs_svg__j"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(78.384 116.916) scale(393.607)"
      >
        <stop />
        <stop offset={0.007} stopColor="#090909" />
        <stop offset={0.048} stopColor="#373737" />
        <stop offset={0.093} stopColor="#626262" />
        <stop offset={0.142} stopColor="#888" />
        <stop offset={0.195} stopColor="#A8A8A8" />
        <stop offset={0.254} stopColor="#C4C4C4" />
        <stop offset={0.32} stopColor="#DADADA" />
        <stop offset={0.397} stopColor="#EBEBEB" />
        <stop offset={0.493} stopColor="#F6F6F6" />
        <stop offset={0.627} stopColor="#FDFDFD" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="ace-clubs_svg__l"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(78.384 116.916) scale(393.607)"
      >
        <stop stopColor="#fff" />
        <stop offset={0.141} stopColor="#fff" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="ace-clubs_svg__m"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(180 149.576 -.082) scale(462.106)"
      >
        <stop offset={0.099} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="ace-clubs_svg__o"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(180 149.576 -.082) scale(462.106)"
      >
        <stop offset={0.099} stopColor="#fff" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
    </defs>
  </svg>
);

export default SvgAceClubs;
